import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "privacy page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("section", { class: "privacy-card glass-card" }, [
      _createElementVNode("h1", null, "Boozelog Privacy Policy"),
      _createElementVNode("p", { class: "updated" }, "Last updated: December 31, 2025"),
      _createElementVNode("p", null, " Boozelog uses Apple Health (HealthKit) data to log drinks and estimate alcohol level trends. HealthKit is the source of truth for your drink data. "),
      _createElementVNode("p", null, " Your data stays on your device and within Apple Health. Boozelog does not sell or share your personal data with third parties. "),
      _createElementVNode("p", null, [
        _createTextVNode(" If you have questions, contact "),
        _createElementVNode("a", { href: "mailto:general@henium.com" }, "general@henium.com"),
        _createTextVNode(". ")
      ])
    ], -1)
  ])))
}